<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Dettaglio bilancio previsionale
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <div class="pt-5 grid grid-cols-4 gap-3">
                <div class="flex flex-col col-span-3">
                    <Field field_name="Cliente"
                           :errors="getErrors('cliente_id')"
                           placeholder="Cliente">
                        <VueMultiselect @search-change="clienteAutocomplete.search"
                                        :loading="clienteAutocomplete.isLoading"
                                        :options="clienteAutocomplete.options"
                                        v-model="clienteAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Business Unit" placeholder="Business Unit"
                           :errors="getErrors('business_unit_id')">
                        <VueMultiselect :searchable="true"
                                        :internal-search="false"
                                        :loading="buAutocomplete.isLoading"
                                        trackBy="id"
                                        label="label"
                                        v-model="buAutocomplete.selection"
                                        :options="buAutocomplete.options"
                                        @search-change="buAutocomplete.search"
                                        :multiple="false"
                                        class="next-vue-multiselect-single"
                                        :close-on-select="true" :clear-on-select="true"
                                        placeholder="Business Unit"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                        >
                            <template v-slot:tag="{option, remove}">
                            <span
                                class="relative inline-block p-2 border border-next-neu hover:border-next-orange group mr-2 mb-2">
                                <span class="mr-2">{{ option.label }}</span>
                                <i tabindex="1" @click.stop.prevent="remove(option)"
                                   class="cursor-pointer fa fa-times text-next-gray-md group-hover:text-next-orange p-0"></i>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Anno" v-model="model.anno" type="number" :inputAttrs="{step:'1'}"
                           :errors="getErrors('anno')">
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Previsionale" v-model="model.previsto" type="number" :inputAttrs="{step:'0.01'}"
                           :errors="getErrors('previsto')">
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Progressivo" v-model="model.progresso" type="number" :inputAttrs="{step:'0.01'}"
                           :errors="getErrors('progresso')">
                    </Field>
                </div>
            </div>

            <div class="flex pt-3 justify-end">
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "@/components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ModalFigli from "@/components/ModalFigli.vue";
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Autocomplete from "@/setup/Autocomplete";
import bilanciPrevisionaliManager from "@/api/BilanciPrevisionaliManager";
import clientiManager from "@/api/Clienti";
import businessUnitsManager from "@/api/BusinessUnits";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";

@Options({
    name: 'DettaglioBilancioPrevisionali',
    components: {
        MultiselectOption,
        NextButton,
        Loading,
        Field,
        Alert
    },

    props: {
        id: {
            type: [String, Number],
            required: true
        },
    }
})
export default class DettaglioBilancioPrevisionali extends Vue {
    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager))
    model = {anno: '', previsto: 0, progresso: 0, cliente_id:null, business_unit_id:null}
    id!: number
    errors = {}
    esito = false
    response_message = ''

    created() {
        this.fetchRuoloProfessionale()
        this.clienteAutocomplete.search('',0)
        this.buAutocomplete.search('',0)
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    fetchRuoloProfessionale() {
        if (this.id) {
            bilanciPrevisionaliManager.detail(this.id).then((response) => {
                this.model = response.data
            }).then(() => {
                this.clienteAutocomplete.retrieve(this.model.cliente_id)
                this.buAutocomplete.retrieve(this.model.business_unit_id)
            })
        }
    }

    @Watch('clienteAutocomplete.selection')
    changeCliente() {
        this.model.cliente_id = this.clienteAutocomplete.selection.id
    }

    @Watch('buAutocomplete.selection')
    changeBu() {
        this.model.business_unit_id = this.buAutocomplete.selection.id
    }

    save() {
        if (this.id) {
            bilanciPrevisionaliManager.update(this.id, this.model).then(() => {
                this.esito = true
                this.response_message = 'Salvataggio avvenuto corretamente'
            }).catch((res) => {
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        } else {
            bilanciPrevisionaliManager.create(this.model).then((res: any) => {
                //@ts-ignore
                this.$router.replace({name: 'BilanciPrevisionali'})
            }).catch((res) => {
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        }
    }
}
</script>


<style lang="scss">

</style>
